import React, { useEffect, useState } from "react"
import { useNavigate } from "react-router-dom"
import CustomButton from "../../components/OnboardingComponents/CustomButton"
import loginIcon from "../../assets/images/city-hub/login.svg"
import sendIcon from "../../assets/images/city-hub/send.svg"
import {
  PUBLIC_MARKETING_LINKS,
  PUBLIC_SITE_HOME,
  REQUEST_INVITE_PATH,
} from "./publicCityPaths"

/**
 * Public city header matching marketing mock:
 * AMOK.EARTH · Mission/Projects/Blog/Careers · Invite · Login
 */
const PublicSiteHeader = () => {
  const navigate = useNavigate()
  const [isMenuOpen, setIsMenuOpen] = useState(false)

  useEffect(() => {
    if (!isMenuOpen) return undefined
    const onKeyDown = event => {
      if (event.key === "Escape") setIsMenuOpen(false)
    }
    window.addEventListener("keydown", onKeyDown)
    return () => window.removeEventListener("keydown", onKeyDown)
  }, [isMenuOpen])

  useEffect(() => {
    document.body.classList.toggle("public-site--menu-open", isMenuOpen)
    return () => document.body.classList.remove("public-site--menu-open")
  }, [isMenuOpen])

  const closeMenu = () => setIsMenuOpen(false)

  return (
    <header className="public-site-header">
      <div className="public-site-header__inner">
        <a
          href={PUBLIC_SITE_HOME}
          className="public-site-header__logo"
          aria-label="Amok Earth home"
        >
          AMOK.EARTH
        </a>

        <div className="public-site-header__right">
          <nav className="public-site-header__nav" aria-label="Menu">
            <ul className="public-site-header__menu">
              {PUBLIC_MARKETING_LINKS.map(item => (
                <li key={item.href}>
                  <a href={item.href}>{item.label}</a>
                </li>
              ))}
            </ul>
          </nav>

          <div className="public-site-header__actions">
            <CustomButton
              variant="secondary"
              size="md"
              trailingIconSrc={sendIcon}
              trailingIconAlt=""
              className="public-site-header__btn public-site-header__btn--invite"
              onClick={() => navigate(REQUEST_INVITE_PATH)}
            >
              Request an Invite
            </CustomButton>
            <CustomButton
              variant="primary"
              size="md"
              trailingIconSrc={loginIcon}
              trailingIconAlt=""
              className="public-site-header__btn public-site-header__btn--login"
              onClick={() => navigate("/login")}
            >
              Login
            </CustomButton>

            <button
              type="button"
              className="public-site-header__menu-toggle"
              aria-label={isMenuOpen ? "Close menu" : "Open menu"}
              aria-expanded={isMenuOpen}
              onClick={() => setIsMenuOpen(open => !open)}
            >
              <span className="public-site-header__burger" aria-hidden="true" />
            </button>
          </div>
        </div>
      </div>

      {isMenuOpen ? (
        <div
          className="public-site-header__drawer"
          role="dialog"
          aria-modal="true"
        >
          <nav aria-label="Mobile menu">
            <ul className="public-site-header__drawer-menu">
              {PUBLIC_MARKETING_LINKS.map(item => (
                <li key={item.href}>
                  <a href={item.href} onClick={closeMenu}>
                    {item.label}
                  </a>
                </li>
              ))}
            </ul>
          </nav>
          <div className="public-site-header__drawer-actions">
            <CustomButton
              variant="secondary"
              size="md"
              fullWidth
              trailingIconSrc={sendIcon}
              trailingIconAlt=""
              onClick={() => {
                closeMenu()
                navigate(REQUEST_INVITE_PATH)
              }}
            >
              Request an Invite
            </CustomButton>
            <CustomButton
              variant="primary"
              size="md"
              fullWidth
              trailingIconSrc={loginIcon}
              trailingIconAlt=""
              onClick={() => {
                closeMenu()
                navigate("/login")
              }}
            >
              Login
            </CustomButton>
          </div>
        </div>
      ) : null}
    </header>
  )
}

export default PublicSiteHeader
